import type { RefCallback } from "react"
import { useCallback, useRef } from "react"
import { Juggling } from "@motley/design"

type Args = {
  fetchNextPage: () => unknown
  isFetchingNextPage: boolean
}

export default function FetchMore({ fetchNextPage, isFetchingNextPage }: Args) {
  const observerRef = useRef<IntersectionObserver>(undefined)

  const ref: RefCallback<HTMLElement> = useCallback(
    (el) => {
      if (observerRef.current) {
        observerRef.current.disconnect()
      }

      observerRef.current = new IntersectionObserver((entries) => {
        if (entries[0]?.isIntersecting) {
          fetchNextPage()
        }
      })

      if (el) {
        observerRef.current.observe(el)
      }
    },
    [fetchNextPage],
  )

  return (
    <div ref={ref}>
      {isFetchingNextPage && <Juggling size={24} className="m-1" />}
    </div>
  )
}
